export const SET_FORM_VALUE = "SET_FORM_VALUE@ALERT"
export const SET_FORM_VALUEOBJ = "SET_FORM_VALUEOBJ@ALERT"
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE@ALERT"
export const CLEAR_ALL_ERROR_MESSAGE = "CLEAR_ALL_ERROR_MESSAGE@ALERT"
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE@ALERT"
export const LOAD_API_DATA="LOAD_API_DATA@ALERT"
export const SET_API_DATA = "SET_API_DATA@ALERT"
export const SET_FORM_OPTION = "SET_FORM_OPTION@ALERT"